<div
	class="global-container"
	[ngClass]="{ 'ds-dark-theme': darkThemeEnabled }"
	*ngIf="showUI | async"
	ondragstart="return false"
	[style.min-height]="!hideScroll ? '100%' : 'auto'">
	<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
	<div class="toasts-wrapper" *ngIf="(toasts$ | async).length">
		<div class="toasts">
			<div class="toast" *ngFor="let toast; index as i; of: toasts$ | async">
				<app-custom-toast [user]="user$ | async" [toast]="toast" [indexPosition]="i"></app-custom-toast>
			</div>
		</div>
	</div>

	<div class="top-bar-container">
		<sp-trial-bar *ngIf="isAuthenticated && !isKioskMode && (isAdmin$ | async)"></sp-trial-bar>

		<app-school-toggle-bar *ngIf="isAuthenticated && schools && schools.length > 1 && !hideSchoolToggleBar && !isKioskMode" [schools]="schools">
		</app-school-toggle-bar>
	</div>

	<div style="flex-grow: 1; display: flex; flex-direction: row; align-items: stretch">
		<div style="flex-grow: 1; display: flex; flex-direction: column">
			<div class="router-outlet">
				<div style="flex-grow: 1; display: flex; flex-direction: column">
					<router-outlet></router-outlet>
				</div>
			</div>
			<div class="notification-backdrop" *ngIf="hasCustomBackdrop" [ngStyle]="customStyle"></div>
		</div>

		<ng-container *ngIf="user$ | async as user">
			<app-help-center
				*ngIf="isAuthenticated && !!user && !user.isStudent() && !(helpCenter.isHelpCenterOpen | async) && !isKioskMode"
				(onClick)="openHelpCenter($event)"></app-help-center>
		</ng-container>
		<ng-container *ngIf="helpCenter.isHelpCenterOpen | async">
			<div class="help-center-content-wrapper" #helpCenterDiv id="help-center-content">
				<div class="drag-divider" id="drag-divider"></div>
				<div class="fixed-wrapper" id="fixed-wrapper">
					<div class="help-center-unsubscribe"></div>
					<div class="close-icon-wrapper" (click)="closeHelpCenter()">
						<div class="circle">
							<img class="close-icon" [src]="'./assets/Close (Grey).svg' | resolveAsset" alt="" />
						</div>
					</div>
					<iframe #helpIframe class="help-centre-iframe" id="help-centre-iframe" src="https://www.smartpass.app/help-center" frameborder="0"></iframe>
					<div class="contact-wrapper">
						<div class="call-main">
							<div class="call-contant" (click)="openCallDialog($event)" *ngIf="isAdmin$ | async">
								<img class="pro-icon" *ngIf="!isUserHasPhoneAccess" [src]="'./assets/Plus Plan (Yellow).svg' | resolveAsset" alt="" />
								<img class="call-icon" [src]="'./assets/Call (Gray).svg' | resolveAsset" alt="" />
							</div>
						</div>
						<div class="live-chat open-intercom-btn" id="live-chat">
							<img class="chat-icon" [src]="'./assets/Chat (Blue-Gray).svg' | resolveAsset" alt="" />
							<p class="live-chat-text">Live Chat</p>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>

<div #dialogContainer [@.disabled]="true"></div>
